import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import _ = require("lodash");
import { labels, currentResource } from "../../util/utils";
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifOption from '@ey/motif-react-wrapper/Option';
import { ExcelHelper } from "../../helpers/ExcelHelper";
import { ExcelUtilityHelper } from "../../helpers/common/ExcelUtilityHelper";
import { CellIndexMapping, Constants } from "../../util/UIConstants";
import Utility from "../../util/utilityFunctions";
import { TemplateUIExcelInterface } from "../../services/template/TemplateUIExcelInterface";

const SelectDropdownLayout = (props) => {
  const { title, label, multiple, options, selectedCellAddress, configuration } = props;
  const [selectedValues, setDropdownValue] = useState([]);
  const [dropdownOptionsData, setDropdownOptions] = React.useState<any>(options ? options : []);
  const [dropdownParameters, setDropdownParameters] = React.useState<any>(undefined);
  const [dropDownLabel, setDropDownLabel] = React.useState<string>("");

  const resetDropdownValue = async () => {
    setDropdownOptions([]);
    setDropdownParameters(undefined);
    await ExcelHelper.tryCatchRunAsync(async (context) => {
      let dataObject;
      const cellAddress = selectedCellAddress;

      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const cell = sheet.getRange(cellAddress);

      // Load the protection property of the cell
      cell.load("format/protection");

      await context.sync();

      // Check if the cell is protected
      if (cell.format.protection.locked) {
        return; // Exit the function if the cell is protected
      }

      let cellName = Utility.findNonNumericData(cellAddress);
      let cellIndex = CellIndexMapping.findIndex((cell) => cell === cellName);
      let columnInfo = configuration.columns.find((column) => column.CellDisplayIndex === cellIndex);
      let label = currentResource[columnInfo?.CellHeaderResourceName]?.[columnInfo?.CellHeader] ?? columnInfo?.CellHeader;
      setDropDownLabel(label);

      if (columnInfo?.referenceData?.showDynamicDropdown) {
        const {
          referenceDataCellNameStartAddress,
          referenceDataCellNameEndAddress,
          referenceDataCellRowStartIndex,
          referenceDataCellRowIndexMax,
          outputDataattributes,
        } = columnInfo.referenceData;

        if (referenceDataCellNameStartAddress) {
          await ExcelHelper.tryCatchRunAsync(async (context) => {
            dataObject = await TemplateUIExcelInterface.getDataFromSheet(
              Constants.MasterWorkSheetPrefix,
              columnInfo,
              referenceDataCellNameStartAddress,
              referenceDataCellNameEndAddress,
              referenceDataCellRowStartIndex,
              referenceDataCellRowIndexMax,
              outputDataattributes,
              props.configuration
            );
          });
        }

        if (dataObject != null) {
          setDropdownParameters({
            cellIndex: cellIndex,
            columnInfo: columnInfo,
            cellRangeAddress: cellAddress,
          });
          let dropdownData = dataObject;
          if (dropdownData != undefined) {
            let options = dataObject;
            options = _.uniqBy(options, "value");

            setDropdownOptions(options);
          }
          let cellData = await ExcelUtilityHelper.getCellValue(
            context,
            context.workbook.worksheets.getActiveWorksheet(),
            selectedCellAddress
          );

          let delimiter = "; ";
          if (columnInfo?.referenceData?.delimiter) {
            delimiter = columnInfo.referenceData.delimiter;
          }

          let cellDataSelected = cellData
            ?.toString()
            ?.split(delimiter)
            .map((item) => item);
          setDropdownValue(cellDataSelected);
        }
      }
    });
  };

  useEffect(() => {
    if (selectedCellAddress) {
      resetDropdownValue();
    }
  }, [selectedCellAddress]);

  const onChange = async (e) => {
    await callBackDropDownChange(e, dropdownParameters);
  };

  const callBackDropDownChange = async (updatedValue, dropdownParameters) => {
    const { cellRangeAddress, columnInfo } = dropdownParameters;
    const separator = columnInfo.CellData?.separator || "; ";
    updatedValue[0]?.toString().trim() === "" && updatedValue.shift();
    const updatedCellData = updatedValue.join(separator);

    await ExcelHelper.tryCatchRunAsync(async (context) => {
      context.runtime.enableEvents = false;
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const cellRange = sheet.getRange(cellRangeAddress);
      cellRange.values = [[updatedCellData]];
      await context.sync();
      context.runtime.enableEvents = true;
      props.callBack && props.callBack(cellRangeAddress);
    });
  };

  return (
    <StyledSelectDropdown className="select-dropdown-wrap">
      {Utility.isNullOrUndefined(dropdownParameters) ? (
        <span></span>
      ) : (
        <MotifFormField title={selectedValues}>
          <MotifLabel className="select-dropdown-label">{dropDownLabel}</MotifLabel>
          <MotifSelect
            ariaLabelledBy="select-label"
            onChange={(e) => onChange(e)}
            multiple={multiple}
            //placeholder="placeholder"
            value={selectedValues}
            visibleOptions={3}
            filter={true}
            searchPlaceholder={labels.search}
            noResultsTemplate={({ message }) => <MotifOption disabled>{labels.noRecordsFound}</MotifOption>}
          >
            {dropdownOptionsData.map((type) => {
              return (
                <MotifOption className={"select-option-wrap"} key={type.value} value={type.value} title={type.value}>
                  {type.value}
                </MotifOption>
              );
            })}
          </MotifSelect>
        </MotifFormField>
      )}
    </StyledSelectDropdown>
  );
};

export default SelectDropdownLayout;

const StyledSelectDropdown = styled.section`
  .select-option-wrap {
    
    span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      font-size: var(--px-12);
    }
    .motif-select-checkbox {
      width: var(--px-16) !important;
      height: var(--px-16) !important;
      min-width: var(--px-16) !important;
    }
  }
  .select-dropdown-label {
    font-size: var(--px-12);
    font-weight: 300; 
    color: var(--neutrals-900);
  }

  .motif-icon svg {
		height: var(--px-17) !important;
	}
  .motif-option {
    font-size: var(--px-12);
    font-weight: 300;
    padding: var(--px-8) var(--px-12);
    line-height: normal;
    .motif-select-checkbox {
      width: var(--px-16) !important;
      height: var(--px-16) !important;
      min-width: var(--px-16) !important;
    }
  }
  .motif-select-checkbox{
    width: var(--px-16) !important;
    height: var(--px-16) !important;
    min-width: var(--px-16) !important;
  }
  .motif-select-search-input {
    font-size: var(--px-12);
  }
  .motif-select-input-text {
    font-size: var(--px-12);
  }
  .motif-select-open .motif-select-options {
    max-height: var(--px-116) !important;
  }
    
`;
